// extracted by mini-css-extract-plugin
export default {"arrow":"style_arrow__erPF4","arrows":"style_arrows__Z73DT"};